
export function shareProtocol(name: string, data: string[]) {
    const result: any = {};

    data.forEach((value) => {
        result[value] = {
            get() {
                if (typeof this[name][value] !== 'function') {
                    return this[name][value];
                }
                else {
                    return this[name][value].call(this);
                }
            },
            set(val) {
                if (typeof this[name][value] !== 'function') {
                    this[name][value] = val;
                }
            }
        }
    });

    return result;
}
